<template>
  <b-container fluid>
    <b-row>
      <b-col id="shipping-form">
        <b-row class="justify-content-md-center" v-if="profile && (!profile.profile_address_id || !profile.phone)">
          <b-col cols="12">
            <b-alert show variant="warning">
              <h5 v-translate>Warning</h5>
              <p v-translate>You need to complete some required profile information to be able to ask for a Moover.</p>
              <p v-if="!profile.phone">
                <b-btn v-b-modal.modalEnterPhone variant="warning" v-translate>Enter and verify your mobile phone</b-btn>
              </p>
              <p v-if="!profile.profile_address_id">
                <b-btn v-b-modal.modalEnterAddress variant="warning" :disabled="!profile.phone" v-translate>Enter your address</b-btn>
              </p>
            </b-alert>
          </b-col>
        </b-row>
        <b-row class="justify-content-md-center" v-if="!hasStores">
          <b-col cols="12">
            <b-alert show variant="warning">
              <h5 v-translate>Speed up your shippings!</h5>
              <div v-if="isCompanyAdmin">
                <p v-translate>Fill in the infomation of all your stores, branches and warehouses</p>
                <b-btn :to="{name: 'stores'}" variant="warning" v-translate="{storeIcon: storeIcon}" render-html="true">%{storeIcon} HERE!</b-btn>
              </div>
              <div v-else>
                <p v-translate>You don't have permissions to fill the Stores' info. Please ask your Company Administrator to do it.</p>
              </div>
            </b-alert>
          </b-col>
        </b-row>
        <form class="" role="form" @submit.prevent="submit()">
          <h2 class="mb-4" v-translate>New FOOD Shipping</h2>
          <b-card id="shipping-from">
            <h4><img src="../assets/img/ic_origen.svg" alt=""> <translate>Origin</translate></h4>
            <b-row>
              <div class="form-group col-sm-8">
                <label for="from_address" v-translate>Origin Address <small class="text-danger">(required)</small></label>
                <div class="input-group">
                  <address-autocomplete ref="fromAddress" @selected="selectedFrom" @input="shipping.from_place_id = null" static-items :minCharacter="4" v-if="storesUpdated" />
                </div>
                <small class="form-text text-muted" v-translate>We use Google to validate all addresses, please keep it in mind when you enter yours.</small>
                <input type="hidden" id="from_place_id" name="from_place_id" v-model="shipping.from_place_id">
              </div>
              <div class="form-group col-sm-4">
                <label for="from_extra" v-translate>Floor, door, etc.</label>
                <div class="input-group">
                  <b-form-input id="from_extra" name="from_extra" v-model="shipping.from_extra" class="col-12 form-control" />
                </div>
              </div>
            </b-row>
            <b-collapse id="collapseFrom" :visible="shipping.from_place_id ? true : false">
              <b-row>
                <div class="form-group col-sm-12">
                  <label for="from_contact" v-translate>Origin Contact Name <small class="text-danger">(required)</small></label>
                  <div class="input-group">
                    <b-form-input id="from_contact" name="from_contact" v-model="shipping.from_contact" required />
                  </div>
                </div>
                <div class="form-group col-sm-6">
                  <label for="from_email" v-translate>Origin Contact E-mail <small class="text-danger">(required)</small></label>
                  <div class="input-group">
                    <b-form-input trim id="from_email" name="from_email" v-model="shipping.from_email" type="email" required />
                  </div>
                </div>
                <div class="form-group col-sm-6">
                  <label for="from_phone" v-translate>Origin Contact Phone</label>
                  <div class="input-group">
                    <cleave ref="fromPhone" :options="{ phone: true, phoneRegionCode: this.$cookies.get('country').toLowerCase() }" class="form-control" v-model="shipping.from_phone" autocomplete="nope"></cleave>
                  </div>
                </div>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-checkbox class="save-from"
                    v-model="saveFrom"
                    :value="true"
                    :unchecked-value="false">
                    <span class="switch"><span class="slider round"></span></span> <span v-translate>Save to personal address book</span>
                  </b-form-checkbox>
                </b-col>
              </b-row>
              <b-row>
                <div class="form-group col-sm-6">
                  <label for="from_contact">
                    <translate>Item Description</translate> <em class="text-info"><small><translate>(up to 255 characters)</translate></small></em>
                  </label>
                  <div class="input-group">
                    <b-form-textarea id="description" name="description" v-model="shipping.description" :rows="3" :max-rows="6" @input="countdown('description', 255)" :state="invalid.description" />
                  </div>
                  <p class='text-right' v-bind:class="{'text-danger': invalid.description === false }"><small>{{limits.description}}</small></p>
                  <small class="form-text text-muted"><translate>Please tell us what the item is and a brief description.</translate><br />
                  <translate>i.e.</translate> <em v-translate>A 40" television</em></small>
                </div>
                <div class="form-group col-sm-6">
                  <label for="from_contact">
                    <translate>Special instructions</translate> <em class="text-info"><small><translate>(up to 255 characters)</translate></small></em>
                  </label>
                  <div class="input-group">
                    <b-form-textarea id="from_meta" name="from_meta" v-model="shipping.from_meta" :rows="3" :max-rows="6" @input="countdown('from_meta', 255)" :state="invalid.from_meta" />
                  </div>
                  <p class='text-right' v-bind:class="{'text-danger': invalid.from_meta === false }"><small>{{limits.from_meta}}</small></p>
                  <small class="form-text text-muted"><translate>Do you have any special instruction for our Moover on pick up?</translate><br />
                  <translate>i.e.</translate> <em v-translate>The elevator is not working</em></small>
                </div>
              </b-row>
            </b-collapse>
          </b-card>
          <b-card class="shipping-to">
            <h4><img src="../assets/img/ic_destino.svg" alt=""> <translate>Destination</translate></h4>
            <b-row>
              <div class="form-group col-sm-8">
                <label for="from_address" v-translate>Destination Address <small class="text-danger">(required)</small></label>
                <div class="input-group">
                  <address-autocomplete ref="toAddress" @selected="selectedTo" @input="shipping.to_place_id = null" static-items :minCharacter="4" v-if="storesUpdated" />
                </div>
                <small class="form-text text-muted" v-translate>We use Google to validate all addresses, please keep it in mind when you enter yours.</small>
                <input type="hidden" id="to_place_id" name="to_place_id" v-model="shipping.to_place_id">
              </div>
              <div class="form-group col-sm-4">
                <label for="to_extra" v-translate>Floor, door, etc.</label>
                <div class="input-group">
                  <b-form-input id="to_extra" name="to_extra" v-model="shipping.to_extra" class="col-12 form-control" />
                </div>
              </div>
            </b-row>
            <b-collapse id="collapseTo" :visible="shipping.to_place_id ? true : false">
              <b-row>
                <div class="form-group col-sm-12">
                  <label for="to_contact" v-translate>Destination Contact Name <small class="text-danger">(required)</small></label>
                  <div class="input-group">
                    <b-form-input id="to_contact" name="to_contact" v-model="shipping.to_contact" required />
                  </div>
                </div>
                <div class="form-group col-sm-6">
                  <label for="to_email" v-translate>Destination Contact E-mail</label>
                  <div class="input-group">
                    <b-form-input trim id="to_email" name="to_email" v-model="shipping.to_email" type="email" />
                  </div>
                </div>
                <div class="form-group col-sm-6">
                  <label for="to_phone" v-translate>Destination Contact Phone <small class="text-danger">(required)</small></label>
                  <div class="input-group">
                    <cleave ref="toPhone" :options="{ phone: true, phoneRegionCode: this.$cookies.get('country').toLowerCase() }" class="form-control" v-model="shipping.to_phone" autocomplete="nope" required></cleave>
                  </div>
                </div>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-checkbox class="save-from"
                    v-model="saveTo"
                    :value="true"
                    :unchecked-value="false">
                    <span class="switch"><span class="slider round"></span></span> <span v-translate>Save to personal address book</span>
                  </b-form-checkbox>
                </b-col>
              </b-row>
              <b-row>
                <div class="form-group col-sm-6">
                  <label for="from_contact">
                    <translate>Special instructions</translate> <em class="text-info"><small v-translate>(up to 255 characters)</small></em>
                  </label>
                  <div class="input-group">
                    <b-form-textarea id="to_meta" name="to_meta" v-model="shipping.to_meta" :rows="3" :max-rows="6" @input="countdown('to_meta', 255)" :state="invalid.to_meta" /><br>
                  </div>
                  <p class='text-right' v-bind:class="{'text-danger': invalid.to_meta === false }"><small>{{limits.to_meta}}</small></p>
                  <small class="form-text text-muted"><translate>Do you have any special instruction for our Moover on delivery?</translate><br>
                  <translate>i.e.</translate> <em v-translate>The door bell is not working</em></small>
                </div>
              </b-row>
            </b-collapse>
          </b-card>
          <div id="shipping-form-submit">
            <b-button variant="primary" type="submit" size="lg" :disabled="!hasStores || !$store.getters.profile.company_id || !shipping.from_place_id || !shipping.to_place_id || !shipping.size_id || !this.$store.getters.profile.profile_address_id || !this.$store.getters.profile.phone || posting || !shipping.from_contact || !shipping.from_email || !shipping.to_contact || !budgets.price_formatted || !shipping.to_phone">
              <b-spinner small v-if="posting"></b-spinner>
              <translate>Ask for a Moover! :D</translate>
            </b-button>
          </div>
        </form>
      </b-col>
      <b-col class="d-none d-md-block" id="shipping-map">
        <leaflet-map ref="fullMap" centerMap geolocate fit-always :zoom="14" style="height: 100%;" />
      </b-col>
    </b-row>

    <b-modal id="modalEnterPhone" ref="modalEnterPhone" :hide-footer="true" @shown="focusPhoneInput">
      <div slot="modal-title" v-translate>Verify your mobile phone</div>
      <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
        <phone-validation ref="phoneValidation" @cancel="closeModalPhone" @success="successModalPhone" />
    </b-modal>

    <b-modal id="modalEnterAddress" ref="modalEnterAddress" :hide-footer="true" @shown="focusAddressInput">
      <div slot="modal-title" v-translate>Enter Your Address</div>
      <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
        <add-address ref="addAddress" :ignoreArea="true" :isProfile="true" @cancel="closeModalAddress" @success="successModalAddress" />
    </b-modal>

    <b-modal size="xl" id="modalFromPickPlace" ref="modalFromPickPlace" hide-footer hide-header @hide="$refs.pickFromPlaceMap.pickPlace(0, 0)">
      <place-picker ref="pickFromPlaceMap" hasReference @cancel="closeModalFromPickPlace" @placePicked="setPlacePickedFrom" centerMap fit-always :zoom="17">
        <template v-slot:instructions>
          <p class="mt-3"><translate>Please, click on the map to pick the Origin point. You may also add a text reference or description to help the Courier to find out the place.</translate></p>
        </template>
      </place-picker>
    </b-modal>

    <b-modal size="xl" id="modalToPickPlace" ref="modalToPickPlace" hide-footer hide-header @hide="$refs.pickToPlaceMap.pickPlace(0, 0)">
      <place-picker ref="pickToPlaceMap" hasReference @cancel="closeModalToPickPlace" @placePicked="setPlacePickedTo" centerMap fit-always :zoom="17">
        <template v-slot:instructions>
          <p class="mt-3"><translate>Please, click on the map to pick the Destination point. You may also add a text reference or description to help the Courier to find out the place.</translate></p>
        </template>
      </place-picker>
    </b-modal>

    <modal-need-stores v-if="$frontConfig.stores && $frontConfig.stores.force" />

  </b-container>
</template>
<script>
import AddressMixins from '@/mixins/address.mixin.js'
import { mapGetters } from 'vuex'
import AddressAutocomplete from '@/components/AddressAutocomplete'
import LeafletMap from '@/components/LeafletMap'
import Cleave from 'vue-cleave'
import vueAuthInstance from '@/services/auth'
import auth from '@/store/auth'
import ScheduleDaySlot from '@/components/ScheduleDaySlot'
import PaymentMethodForm from '@/components/PaymentMethodForm'
import AddAddress from '@/components/AddAddress'
import PhoneValidation from '@/components/PhoneValidation'
import Icon from '@/components/Icon'
import { icon } from '@fortawesome/fontawesome-svg-core'
import { faStore } from '@fortawesome/free-solid-svg-icons'
import { ADDRESS_CREATE, FETCH_ADDRESSES, FETCH_PROFILE } from '@/store/actions.type'
import PlacePicker from '@/components/PlacePicker'
import ModalNeedStores from '@/components/ModalNeedStores'

export default {
  name: 'NewShippingPage',
  title() {
    return this.$gettext('New Shipping')
  },
  components: {
    LeafletMap,
    Cleave,
    AddressAutocomplete,
    ScheduleDaySlot,
    PaymentMethodForm,
    PhoneValidation,
    AddAddress,
    Icon,
    PlacePicker,
    ModalNeedStores
  },
  data() {
    return {
      profile: {},
      step: 1,
      completed: 0,
      budgets: [],
      distance: null,
      duration: null,
      courier_type: null,
      price_formatted: null,
      selectedBudget: null,
      vehicleTypes: [],
      shippingTypes: [],
      shippingTypeSelect: [],
      fromAddress: '',
      toAddress: '',
      fromMarker: '',
      toMarker: '',
      markers: [],
      flexCutOutHour: 15,
      opsStartHour: 8,
      shipping: {
        courier_type_id: null,
        from_place_id: null,
        from_extra: null,
        from_contact: null,
        from_email: null,
        from_phone: null,
        to_place_id: null,
        to_extra: null,
        to_contact: null,
        to_email: '',
        to_phone: null,
        to_meta: null,
        price: null,
        currency: null,
        area_id: null,
        user_id: auth.state.uid,
        scheduled_date: null,
        flow: 'automatic',
        shipping_type_id: null,
        external_code: null
      },
      isScheduled: false,
      limits: {},
      invalid: {},
      posting: false,
      // paymentMethods: [],
      vehicleTypesTranslations: [
        this.$gettext('MOTORCYCLE'),
        this.$gettext('CAR'),
        this.$gettext('VAN'),
        this.$gettext('TRUCK')
      ],
      shippingSizes: [],
      shippingSizesDescriptions: {
        'XS': {
          description: this.$gettext('Up to a book')
        },
        'S': {
          description: this.$gettext('Up to a shoes box')
        },
        'M': {
          description: this.$gettext('Up to a laptop')
        },
        'L': {
          description: this.$gettext('Up to a 32" LED television')
        },
        'XL': {
          description: this.$gettext('Up to an electric piano')
        },
        '2XL': {
          description: this.$gettext('Up to a couch')
        },
        '3XL': {
          description: this.$gettext('Up to a pool table')
        }
      },
      saveFrom: false,
      saveTo: false,
      addressesFilters: {
        page: 0,
        limit: 19,
        sort: [{
          key: 'created_at',
          direction: 'desc'
        }],
        filter_groups: [
          {
            filters: [
              {
                key: 'favourite',
                operator: 'eq',
                value: 1
              }
            ]
          }
        ]
      },
      storesUpdated: false,
      storeIcon: icon(faStore).html,
      shippingTypeId: null,
      dropInWarehouse: false
    }
  },
  watch: {
    'shippingTypeId': {
      handler(val) {
        if (val === 'dropInWarehouse') {
          this.shipping.shipping_type_id = this.shippingTypes.find(x => x.name === 'regular').id
          this.dropInWarehouse = true
          this.updateBudget()
        } else {
          this.shipping.shipping_type_id = val
          this.dropInWarehouse = false
          this.updateBudget()
        }
      }
    },
    'shipping.size_id': {
      handler(val) {
        this.updateBudget()
      },
      deep: true
    },
    'shipping.from_place_id': {
      handler(val) {
        this.updateBudget()
      },
      deep: true
    },
    'shipping.to_place_id': {
      handler(val) {
        this.updateBudget()
      },
      deep: true
    },
    'shipping.from_phone': {
      handler(val) {
        if (val.indexOf('+') === -1) {
          this.$refs.fromPhone.cleave.setRawValue('+' + this.$frontConfig.i18n.phonePrefix)
        }
      },
      deep: true
    },
    'shipping.to_phone': {
      handler(val) {
        if (val.indexOf('+') === -1) {
          this.$refs.toPhone.cleave.setRawValue('+' + this.$frontConfig.i18n.phonePrefix)
        }
      },
      deep: true
    }
  },
  computed: {
    authHeaders() {
      return {
        'Authorization': 'Bearer ' + vueAuthInstance.getToken()
      }
    },
    collapseFrom() {
      return this.shipping.from_place_id || false
    },
    collapseTo() {
      return this.shipping.to_place_id || false
    },
    hasMeliIntegration() {
      return this.$store.getters.profile && this.$store.getters.profile.platform_user_authorizations.findIndex(x => x.platform.slug === 'meli') !== -1
    },
    stepOne() {
      return (
        this.shipping.from_place_id &&
        this.shipping.from_contact &&
        this.shipping.from_email
      )
    },
    stepTwo() {
      return (
        this.shipping.to_place_id &&
        this.shipping.to_contact &&
        this.shipping.to_email
      )
    },
    stepThree() {
      return (
        this.stepOne &&
        this.stepTwo &&
        this.shipping.courier_type_id
      )
    },
    isCompany() {
      return this.$store.getters.profile.company_id || false
    },
    isFlex() {
      return this.shippingTypes.length > 0 ? this.shipping.shipping_type_id === this.shippingTypes.find(x => x.name === 'mercado_flex').id : false
    },
    is90Minutes() {
      return this.shippingTypes.length > 0 ? this.shipping.shipping_type_id === this.shippingTypes.find(x => x.name === 'minutes_90').id : false
    },
    isRegular() {
      return this.shippingTypes.length > 0 ? this.shipping.shipping_type_id === this.shippingTypes.find(x => x.name === 'regular').id : false
    },
    hasStores() {
      return this.user && this.user.company && this.user.company.stores.length > 0
    },
    hasCompany() {
      return this.$store.getters.profile && this.$store.getters.profile.company_id !== null
    },
    isCompanyAdmin() {
      return this.hasCompany && this.$store.getters.profile.company && this.$store.getters.profile.roles.findIndex(x => x.name === 'company-admin') !== -1
    },
    ...mapGetters([
      'user',
      'addresses'
    ])
  },
  mixins: [AddressMixins],
  created() {
    this.fetchProfile()
    this.fetchVehicles()
    this.fetchShippingTypes()
    this.fetchShippingSizes()
  },
  methods: {
    updateBudget() {
      if (this.shipping.from_place_id && this.shipping.to_place_id && this.shipping.size_id) {
        this.checkBudgetsNew()
      } else {
        this.budgets = {
          price_formatted: null
        }
      }
    },
    fetchProfile() {
      this.$store.dispatch(FETCH_ADDRESSES, {filters: this.addressesFilters}).then(() => {
        localStorage.setItem('savedAddresses', JSON.stringify(this.addresses))
        this.$store.dispatch(FETCH_PROFILE)
          .then(response => {
            console.log(this.user)
            this.profile = this.user
            this.$store.commit('setEmail', this.user.email)
            let payload = { profile: this.user }
            this.$store.commit('setProfile', payload)
            if (this.user.profile_address_id === null) {
              this.user.profile_address = {
                place: {
                  formatted_address: null
                }
              }
            }
            if (this.user.company.stores.length > 0) {
              localStorage.setItem('companyStores', JSON.stringify(this.user.company.stores))
            } else {
              localStorage.removeItem('companyStores')
            }
            this.storesUpdated = true
          })
      })
    },
    focusPhoneInput() {
      this.$refs.phoneValidation.$refs.phoneInput.$el.focus()
    },
    closeModalPhone() {
      this.$refs.modalEnterPhone.hide()
    },
    successModalPhone() {
      this.fetchProfile()
      this.$refs.modalEnterPhone.hide()
    },
    focusAddressInput() {
      this.$refs.addAddress.$refs.addressAutocomplete.$el.children[0].focus()
    },
    closeModalAddress() {
      this.$refs.modalEnterAddress.hide()
    },
    successModalAddress() {
      console.log('YASSS')
      setTimeout(function () {
        this.fetchProfile()
        this.$refs.modalEnterAddress.hide()
      }.bind(this), 500)
    },
    countdown(value, limit) {
      this.limits[value] = this.shipping[value] ? limit - this.shipping[value].length : null
      this.invalid[value] = this.shipping[value] ? this.shipping[value].length <= limit : null
    },
    fetchVehicles() {
      this.$http.get(this.$appConfig.api.baseUrl + 'vehicle-types')
        .then(response => {
          this.vehicleTypes = response.body.data
        }).catch(response => {

        })
    },
    fetchShippingTypes() {
      this.$http.get(this.$appConfig.api.baseUrl + 'shipping-types')
        .then(response => {
          this.shippingTypes = response.body.data
          this.shippingTypeSelect = [
            {
              text: this.$pgettext('shipping types', 'Regular'),
              value: this.shippingTypes.find(x => x.name === 'regular').id
            },
            {
              text: this.$pgettext('shipping types', '2 Hours'),
              value: this.shippingTypes.find(x => x.name === 'minutes_90').id
            }
          ]
          if (this.isCompany && this.hasMeliIntegration) {
            this.shippingTypeSelect.push({
              text: this.$pgettext('shipping types', 'Mercado Envíos FLEX'),
              value: this.shippingTypes.find(x => x.name === 'mercado_flex').id
            })
          }
          this.shippingTypeSelect.push({
            text: this.$pgettext('shipping types', 'Drop on Moova warehouse'),
            value: 'dropInWarehouse'
          })
          this.shippingTypeId = this.shippingTypes.find(x => x.name === 'food').id
          this.shipping.shipping_type_id = this.shippingTypeId
        }).catch(response => {

        })
    },
    fetchShippingSizes() {
      let params = {
        sort: [{
          key: 'max_weight',
          direction: 'asc'
        }]
      }
      this.$http.get(this.$appConfig.api.baseUrl + 'sizes', params)
        .then(response => {
          this.shippingSizes = response.body.data
          this.shipping.size_id = this.shippingSizes.find(x => x.name === 'XS').id
        }).catch(response => {

        })
    },
    prev() {
      this.step--
    },
    next() {
      this.step++
    },
    checkCollapseFrom() {
      this.collapseFrom = this.shipping.from_place_id || false
    },
    submit() {
      if (this.saveFrom) {
        let fromAddress = {
          reference: this.shipping.from_contact,
          contact: this.shipping.from_contact,
          email: this.shipping.from_email,
          phone: this.shipping.from_phone,
          place_id: this.shipping.from_place_id,
          address_extra: this.shipping.from_extra,
          favourite: true
        }
        this.$store.dispatch(ADDRESS_CREATE, fromAddress)
      }
      if (this.saveTo) {
        let toAddress = {
          reference: this.shipping.to_contact,
          contact: this.shipping.to_contact,
          email: this.shipping.to_email,
          phone: this.shipping.to_phone,
          place_id: this.shipping.to_place_id,
          address_extra: this.shipping.to_extra,
          favourite: true
        }
        this.$store.dispatch(ADDRESS_CREATE, toAddress)
      }
      this.shipping.from_phone = this.shipping.from_phone === '+54' ? null : this.shipping.from_phone
      this.shipping.to_phone = this.shipping.to_phone === '+54' ? null : this.shipping.to_phone
      this.shipping.flow = 'automatic'

      if (this.isFlex && this.moment().format('HH') >= this.flexCutOutHour) {
        this.shipping.scheduled_date = this.moment().add(1, 'day').startOf('day').add(this.opsStartHour, 'hours').utc().format('YYYY-MM-DD HH:mm:ss')
      }
      this.posting = true

      this.$http.post(this.$appConfig.api.baseUrl + 'shippings', this.shipping)
        .then(response => {
          if (this.shipping.flow === 'automatic') {
            window.open('/shippings/' + response.body.id)
            location.reload()
          } else if (!this.dropInWarehouse) {
            let params = {
              status: 'READY'
            }
            this.$http.post(this.$appConfig.api.baseUrl + 'shippings/' + response.body.id + '/status', params)
              .then(response => {
                this.$router.push({ name: 'shipping', params: { id: response.body.shipping_id }, query: { created: true } })
              })
          } else {
            this.$router.push({ name: 'shipping', params: { id: response.body.id }, query: { created: true } })
          }
        }).catch(e => {
          this.posting = false
        })
    },
    autocompleteEndpoint(query) {
      if (query.length >= 3) {
        return this.$appConfig.api.baseUrl + 'autocomplete?query=' + query
      } else {
        return
      }
    },
    selectedFrom(item) {
      if (item.reference) {
        this.shipping.from_contact = item.contact
        this.shipping.from_email = item.email
        if (item.phone) {
          this.$refs.fromPhone.cleave.setRawValue(item.phone.indexOf('+') === -1 ? '+' + this.$frontConfig.i18n.phonePrefix + item.phone.replace(/\s/g, '') : item.phone.replace(/\s/g, ''))
        } else {
          this.$refs.fromPhone.cleave.setRawValue('+' + this.$frontConfig.i18n.phonePrefix)
        }
        this.shipping.from_extra = item.address_extra
        this.checkFromPlace({id: item.place_id, main_text: item.place.formatted_address, secondary_text: ''})
      } else {
        this.checkFromPlace(item)
      }
    },
    async checkFromPlace(place) {
      await this.checkPlace(place)
      this.$nextTick(() => {
        if (this.theCheckedAddress.id) {
          this.fromAddress = this.theCheckedAddress.formatted_address
          this.shipping.area_id = this.theCheckedAddress.in_area.id
          this.setFromPlaceId(this.theCheckedAddress.id)
          this.centerFrom(this.theCheckedAddress.lat, this.theCheckedAddress.lng)
          this.fromMapCoords = this.theCheckedAddress.lat + ',' + this.theCheckedAddress.lng
          this.fromMarker = '&markers=anchor:center|icon:https://cdn.zeplin.io/5bb46258bbbcc034a5a4f620/components/208E9791-5C6D-46B5-948C-CC2A3C871788.png|' + this.theCheckedAddress.lat + ',' + this.theCheckedAddress.lng
          this.fromMapSize = '600x150'
          this.selectedBudget = null
          this.shipping.courier_type_id = null
          this.theCheckedAddress = {}
        } else if (this.theCheckedAddress.validAddress === false) {
          this.$refs.modalFromPickPlace.show()
          setTimeout(function () {
            this.$refs.pickFromPlaceMap.center = {
              lat: this.theCheckedAddress.lat,
              lng: this.theCheckedAddress.lng
            }
            this.$refs.pickFromPlaceMap.reference = this.$refs.fromAddress.searchQuery
            this.$refs.pickFromPlaceMap.styles = 'height: 500px;'
          }.bind(this), 100)
        }
      })
    },
    setFromPlaceId(placeId) {
      this.shipping.from_place_id = placeId
    },
    setPlacePickedFrom(place) {
      this.$refs.fromAddress.searchQuery = place.formatted_address.replace(', GT', '') // HACK: delete last GT part
      this.fromAddress = place.formatted_address
      this.shipping.area_id = place.in_area.id
      this.setFromPlaceId(place.id)
      this.centerFrom(place.lat, place.lng)
      this.shipping.from_meta = place.reference ? place.reference + ' - ' + (this.shipping.from_meta || '') : this.shipping.from_meta
      this.$refs.modalFromPickPlace.hide()
    },
    closeModalFromPickPlace() {
      this.$refs.modalFromPickPlace.hide()
    },
    centerFrom(lat, lng) {
      if (this.markers.findIndex(x => x.id === '0') !== -1) {
        this.markers.splice(this.markers.findIndex(x => x.id === '0'), 1)
      }
      this.markers.push({
        id: '0',
        lat: lat,
        lng: lng,
        icon: this.$appConfig.staticBaseUrl + 'static/img/ic_origin_on.svg',
        x: 10,
        y: 10,
        infoText: this.$gettext('Origin'),
        tooltip: true
      })
      this.$refs.fullMap.addMarkers(this.markers)
    },
    selectedTo(item) {
      if (item.reference) {
        this.shipping.to_contact = item.contact
        this.shipping.to_email = item.email
        if (item.phone) {
          this.$refs.toPhone.cleave.setRawValue(item.phone.indexOf('+') === -1 ? '+' + this.$frontConfig.i18n.phonePrefix + item.phone.replace(/\s/g, '') : item.phone.replace(/\s/g, ''))
        } else {
          this.$refs.toPhone.cleave.setRawValue('+' + this.$frontConfig.i18n.phonePrefix)
        }
        this.shipping.to_extra = item.address_extra
        this.checkToPlace({id: item.place_id, main_text: item.place.formatted_address, secondary_text: ''})
      } else {
        this.checkToPlace(item)
      }
    },
    async checkToPlace(place) {
      await this.checkPlace(place)
      this.$nextTick(() => {
        if (this.theCheckedAddress.id) {
          this.toAddress = this.theCheckedAddress.formatted_address
          this.shipping.area_id = this.theCheckedAddress.in_area.id
          this.setToPlaceId(this.theCheckedAddress.id)
          this.centerTo(this.theCheckedAddress.lat, this.theCheckedAddress.lng)
          this.toMapCoords = this.theCheckedAddress.lat + ',' + this.theCheckedAddress.lng
          this.toMarker = '&markers=anchor:center|icon:https://cdn.zeplin.io/5bb46258bbbcc034a5a4f620/components/208E9791-5C6D-46B5-948C-CC2A3C871788.png|' + this.theCheckedAddress.lat + ',' + this.theCheckedAddress.lng
          this.toMapSize = '600x150'
          this.selectedBudget = null
          this.shipping.courier_type_id = null
          this.theCheckedAddress = {}
        } else if (this.theCheckedAddress.validAddress === false) {
          this.$refs.modalToPickPlace.show()
          setTimeout(function () {
            this.$refs.pickToPlaceMap.center = {
              lat: this.theCheckedAddress.lat,
              lng: this.theCheckedAddress.lng
            }
            this.$refs.pickToPlaceMap.reference = this.$refs.toAddress.searchQuery
            this.$refs.pickToPlaceMap.styles = 'height: 500px;'
          }.bind(this), 100)
        }
      })
    },
    setToPlaceId(placeId) {
      this.shipping.to_place_id = placeId
    },
    setPlacePickedTo(place) {
      this.$refs.toAddress.searchQuery = place.formatted_address.replace(', GT', '') // HACK: delete last GT part
      this.toAddress = place.formatted_address
      this.setToPlaceId(place.id)
      this.centerTo(place.lat, place.lng)
      this.shipping.to_meta = place.reference ? place.reference + ' - ' + (this.shipping.to_meta || '') : this.shipping.to_meta
      this.$refs.modalToPickPlace.hide()
    },
    closeModalToPickPlace() {
      this.$refs.modalToPickPlace.hide()
    },
    centerTo(lat, lng) {
      if (this.markers.findIndex(x => x.id === '1') !== -1) {
        this.markers.splice(this.markers.findIndex(x => x.id === '1'), 1)
      }
      this.markers.push({
        id: '1',
        lat: lat,
        lng: lng,
        icon: this.$appConfig.staticBaseUrl + 'static/img/ic_destination_on.svg',
        x: 10,
        y: 10,
        infoText: this.$gettext('Destination'),
        tooltip: true
      })
      this.$refs.fullMap.addMarkers(this.markers)
      this.$refs.fullMap.fitted = false
      this.$refs.fullMap.fitMap()
    },
    checkBudgetsNew() {
      this.selectedBudget = null
      this.shipping.courier_type_id = null
      this.$nextTick(() => {
        this.$http.post(this.$appConfig.api.baseUrl + 'budgets?from=' + this.shipping.from_place_id + '&to=' + this.shipping.to_place_id + '&size_id=' + this.shipping.size_id + '&shipping_type_id=' + this.shipping.shipping_type_id)
          .then(response => {
            if (response.ok) {
              response.json().then(json => {
                this.budgets = json
                this.shipping.currency = json.currency
                console.log(json)
              })
            }
          }, error => {
            if (error.status === 404) {
              let obj = {
                title: 'ERROR',
                message: this.$gettextInterpolate(this.$gettext('<p>Sorry, there is no quoter defined for this address combination.</p><p>Please, contact <a href="mailto:%{helpEmail}">%{helpEmail}</a> with the details of your shipping to get a solution.</p>'), {helpEmail: this.helpEmail}),
                type: 'error',
                customCloseBtnText: this.$gettext('Close')
              }
              this.$root.$children[0].$refs.simplert.openSimplert(obj)
            }
          })
      })
    },
    checkBudgets() {
      this.selectedBudget = null
      this.shipping.courier_type_id = null
      this.$http.get(this.$appConfig.api.baseUrl + 'budgets?area=' + this.shipping.area_id + '&from=' + this.shipping.from_place_id + '&to=' + this.shipping.to_place_id)
        .then(response => {
          if (response.ok) {
            response.json().then(json => {
              this.budgets = json.budgets
              for (let i = 0; i < json.budgets.length; i++) {
                for (let n = 0; n < this.vehicleTypes.length; n++) {
                  if (this.vehicleTypes[n].id === json.budgets[i].vehicle_type_id) {
                    this.vehicleTypes[n]['price_formatted'] = json.budgets[i].price_formatted
                  }
                }
              }
              this.distance = json.delivery.result.distance.text
              this.duration = json.delivery.result.duration.text
              console.log(json)
            })
          }
        })
    },
    selectBudget(index) {
      for (let i = 0; i < this.budgets.length; i++) {
        if (parseInt(this.budgets[i].vehicle_type_id) === index) {
          this.selectedBudget = this.budgets[i]
          this.shipping.courier_type_id = this.budgets[i].courier_type_id
          this.shipping.price = this.budgets[i].price
          this.shipping.currency = this.budgets[i].currency
          this.courier_type = this.budgets[i].courier_type
          this.price_formatted = this.budgets[i].price_formatted
        }
      }
    },
    schedulerChanged(date) {
      console.log(date.utc().format('YYYY-MM-DD HH:mm:ss'))
      this.shipping.scheduled_date = this.isScheduled ? date.utc().format('YYYY-MM-DD HH:mm:ss') : null
      console.log(this.shipping.scheduled_date)
    },
    formattedDisplay(result) {
      return result.main_text + ', ' + result.secondary_text
    }
  }
}

</script>
<style lang="scss">
.shipping-trigger {
  position: relative;

  img {
    width: 100%;
    height: auto;
  }

  .modal-trigger {
    position: absolute;
    width: 100%;
    height: 100%;

    .btn {
      position: absolute;
      bottom: 10px;
      left: 50%;
      transform: translateX(-50%);
    }
  }

  &.from {
    .modal-trigger {
      background: rgba(40, 208, 182, .3);
    }

    .shipping-data {
      background: rgba(40, 208, 182, .3);
      padding: 1rem;
      cursor: pointer;
    }
  }

  &.to {
    .modal-trigger {
      background: rgba(79, 160, 255, .3);
    }

    .shipping-data {
      background: rgba(79, 160, 255, .3);
      padding: 1rem;
      cursor: pointer;
    }
  }
}

.courier_row {
  min-height: 2.5rem;
  label {
    font-size: 1rem
  }
  .courier_type_1 {
    background: url(../assets/img/ic_field_moto_blue.svg) no-repeat 10px 50%;
    padding: 20px 0 20px 70px;
    &.text-muted {
      background-image: url(../assets/img/ic_field_moto_gray.svg);
      color: #999 !important;
    }
  }

  .courier_type_2 {
    background: url(../assets/img/ic_field_car_blue.svg) no-repeat 10px 50%;
    padding: 20px 0 20px 70px;
    &.text-muted {
      background-image: url(../assets/img/ic_field_car_gray.svg);
      color: #999 !important;
    }
  }

  .courier_type_3 {
    background: url(../assets/img/ic_field_van_blue.svg) no-repeat 15px 50%;
    padding: 20px 0 20px 70px;
    &.text-muted {
      background-image: url(../assets/img/ic_field_van_gray.svg);
      color: #999 !important;
    }
  }

  .courier_type_4 {
    background: url(../assets/img/ic_field_camioneta_blue.svg) no-repeat 10px 50%;
    padding: 20px 0 20px 70px;
    &.text-muted {
      background-image: url(../assets/img/ic_field_camioneta_gray.svg);
      color: #999 !important;
    }
  }
}

.modal-select-budget {
  .card {
    .courier_type_1 {
      background: url(../assets/img/ic_field_moto_gray.svg) no-repeat 0 50%;
      padding-left: 60px;
    }

    .courier_type_2 {
      background: url(../assets/img/ic_field_car_gray.svg) no-repeat 0 50%;
      padding-left: 60px;
    }

    .courier_type_3 {
      background: url(../assets/img/ic_field_camioneta_gray.svg) no-repeat 0 50%;
      padding-left: 60px;
    }

    &:hover {
      .courier_type_1 {
        background: url(../assets/img/ic_field_moto_blue.svg) no-repeat 0 50%;
        padding-left: 60px;
      }

      .courier_type_2 {
        background: url(../assets/img/ic_field_car_blue.svg) no-repeat 0 50%;
        padding-left: 60px;
      }

      .courier_type_3 {
        background: url(../assets/img/ic_field_camioneta_blue.svg) no-repeat 0 50%;
        padding-left: 60px;
      }
    }
  }
}

/* The switch - the box around the slider */
.save-from .switch {
  position: relative;
  display: inline-block;
  width: 32px;
  height: 20px;
}

/* Hide default HTML checkbox */
.save-from input {
  opacity: 0;
  width: 0;
  height: 0;
}
.save-from {
  padding-left: 0;
  margin-bottom: 1.5rem;
  label {
    span {
      vertical-align: bottom;
    }
    &:before, &after {
      display: none;
    }
  }
}



/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: .15s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 12px;
  width: 12px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  transition: .15s;
}

input:checked + label .slider {
  background-color: #2196F3;
}

input:focus + label .slider {
  box-shadow: 0 0 1px #2196F3;
}

input:checked + label .slider:before {
  -webkit-transform: translateX(12px);
  -ms-transform: translateX(12px);
  transform: translateX(12px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

#shipping-sizes {
  label {
    border-radius: 0 !important;
    margin-bottom: 5px;
    padding: 0.375rem 0.75rem !important;
    h4 {
      text-align: left;
      margin: 5px 0 5px 3.5em;
    }
    h2, h3 {
      margin-bottom: 0;
      span {
        display: inline-block;
        width: 2em;
        vertical-align: middle;
        background: #4fa0ff;
        color: #fff;
        text-align: center;
        border-radius: 3px;
        transition: all 0.15s ease-in-out;
      }
      small {
        font-size: 72%;
      }
    }
    .icon {
      display: inline-block;
      position: absolute;
      top: 50%;
      left: 0;
      height: 4em;
      transform: translateY(-50%);
      svg {
        height: 100%;
        width: auto;
        path {
          mask: none;
          transition: fill 0.15s ease-in-out;
        }
      }
    }
    &:hover, &.active {
      h2 {
        span {
          background: #fff;
          color: #4fa0ff;
        }
      }
      .icon {
        svg {
          path {

            fill: #ffffff
          }
        }
      }
    }
  }
}
#shipping-is-flex {
  label {
    font-size: 13px;
  }
}

</style>
